// URLs
export const URL_ONEPASS_LANDING = "/onepass";
export const URL_ONEPASS_TERMS_AND_CONDITIONS = "/onepass-terms";
export const URL_ONEPASS_OAUTH_REDIRECT = "/oauth_redirect/onepass";
export const URL_ONEPASS_SUBSCRIBE = "/onepass/subscribe";
export const URL_ONEPASS_CONSENT = "/onepass-consent";
export const URL_ONEPASS_SHOP = "/shop/onepass";
export const URL_ONEPASS_MANAGEMENT = "/my-account/onepass-subscription";
export const URL_ONEPASS_PUBLIC_MIGRATION = "/onepass-migration";
export const URL_ONEPASS_HELP = "https://help.catch.com.au/s/articles?catName=OnePass";
// Assets
export const ASSET_PERSON_ONEPASS_FIREWORKS = "https://s.catch.com.au/assets/0001/1042/643cd7ae8a797639530835.png";
export const ASSET_PERSON_DIVISION_BOXES = "https://s.catch.com.au/assets/0001/1042/643e1dacf06fd287122305.png";
export const ASSET_PERSON_CELEBRATING_WITH_CONFETTI = "https://s.catch.com.au/assets/0001/1042/643e1e0c86ceb225372115.png";
export const ASSET_WOMAN_HANDS_UP_WITH_ONEPASS_LIGHT_BG = "https://s.catch.com.au/assets/0001/1042/6448a5aada53b458616313.webp";
export const ASSET_WOMAN_HANDS_UP_WITH_ONEPASS_LIGHT_BG_LANDSCAPE = "https://s.catch.com.au/assets/0001/1042/644b34091cbed820330948.webp";
// Query params
export const ONEPASS_MIGRATION_STATUS_QUERY_PARAM_KEY = "onepass-migration-status";
export const ONEPASS_DOUBLE_SUBSCRIPTION_QUERY_PARAM_KEY = "double-sub";
export const ONEPASS_LINK_QUERY_PARAM_KEY = "link-onepass";
export const ONEPASS_SUCCESS_NOTIFICATION_TOAST_PARAM_KEY = "showmessage";
export const ONEPASS_ELIGIBLE_FOR_MIGRATION_PARAM_KEY = "eligible-for-migration";
// Others
export const HOTLINE_ONEPASS = "1300 222 824";
export const DEFAULT_FREE_TRIAL_DAYS = 30;
export const ONEPASS_MONTHLY_PRICE = 400;
export const ONEPASS_YEARLY_PRICE = 4000;
export const COOKIE_ONEPASS_MIGRATION_MODAL_KEY = "OPMigrationModal";
export * from "./experiments";
